import { useRouter } from "next/router"
import { useEffect, useState } from "react"

/**
 * router.isReady をハイドレーション後に返す。
 *
 * クエリの無い静的ページでは、サーバー描画の isReady が false でブラウザの初回描画が true になる。
 * router.isReady で出し分けるとハイドレーションエラーになるため、初回描画はサーバーに揃えて false を返す。
 */
export const useIsRouterReady = () => {
  const router = useRouter()
  const [isHydrated, setIsHydrated] = useState(false)

  useEffect(() => {
    setIsHydrated(true)
  }, [])

  return isHydrated && router.isReady
}
